<template>
  <div
      class="policy-history-btn w-50px h-50px cursor-pointer shadow rounded-circle bg-primary justify-content-center align-content-center"
      data-bs-toggle="modal" data-bs-target="#policyHistoryPopup">
    <div class="d-flex flex-column text-center">
      <i class="fa-solid fa-clock-rotate-left text-white fs-4"></i>
    </div>
  </div>
  <div class="modal fade" tabindex="-1" id="policyHistoryPopup">
    <div class="modal-dialog my-0 me-0 ms-auto h-100 w-325px modal-dialog-scrollable">
      <div v-if="!loaded" class="modal-content h-100 rounded-0 w-325px">
        <div class="modal-header p-0 border-0 w-100">
          <ul class="nav nav-tabs nav-line-tabs mt-2 fs-6 px-5 w-100">
            <li class="nav-item">
              <span class="nav-link disabled text-gray-800 fw-bold">История:</span>
            </li>
            <li class="nav-item ms-auto me-0">
              <a class="nav-link ms-0 active" data-bs-toggle="tab" href="#drafts">Черновики</a>
            </li>
            <li class="nav-item ms-2 me-0">
              <a class="nav-link ms-0" data-bs-toggle="tab" href="#policies">Договоры</a>
            </li>
          </ul>
        </div>
        <div class="modal-body p-0 h-100">
          <div class="tab-content bg-white p-5 h-100" id="myTabContent">
            <div class="tab-pane fade show active h-100" id="drafts" role="tabpanel">
              <template v-if="drafts && drafts.length > 0">
                <div
                    v-for="item in drafts"
                    :key="item.id"
                    @click="goToRoute(this.getPageName(item.product_type), item.id)"
                    class="d-block text-gray-800 p-5 rounded border mb-3 cursor-pointer border-hover-success"
                    :class="this.$route.query.draft === item.id.toString() ? 'border-success' : ''"
                >
                  <div class="mb-1 ms-1 fw-bold" :class="this.$route.query.draft === item.id ? 'text-success' : ''">{{ item.id }}</div>
                  <div class="text-gray-500 mb-1">
                    <span class="badge badge-secondary me-1 mb-1">{{ item.insurer_document }}</span>
                    <span class="badge badge-light me-1 mb-1">{{ item.product_name }}</span>
                    <span class="badge badge-light me-1 mb-1">{{ item.date }}</span>
                  </div>
                  <div class="ms-1 fs-8" :class="this.$route.query.draft === item.id ? 'text-success' : ''">{{ item.insurer_title }}</div>
                </div>
                <div class="text-muted fs-8 p-3 pt-0 text-center">Отображаются последние 10 записей</div>
              </template>
              <div v-else class="h-100 d-flex justify-content-center align-items-center text-muted flex-column text-center">
                <i class="ki-duotone ki-brifecase-cros fs-4x mb-3 opacity-50">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                </i>
                Записи по черновикам <br> не найдены.
              </div>
            </div>
            <div class="tab-pane fade h-100" id="policies" role="tabpanel">
              <template v-if="policies && policies.length > 0">
                <div
                    v-for="item in policies"
                    :key="item.id"
                    @click="goToRoute(this.getPageName(item.product_type), item.id)"
                    class="d-block text-gray-800 p-5 rounded border mb-3 cursor-pointer border-hover-primary"
                    :class="this.$route.query.draft === item.id.toString() ? 'border-success' : ''"
                >
                  <div class="mb-1 ms-1 fw-bold d-flex align-content-center" :class="this.$route.query.draft === item.id.toString() ? 'text-success' : ''">
                    {{ item.id }}
                    <span v-if="item.hasOwnProperty('status')" class="badge me-1 mb-1 fs-9 text-lowercase ms-2" :class="getStyle(item.status)">{{ item.statusName }}</span>
                  </div>
                  <div class="text-gray-500 mb-1">
                    <span class="badge badge-secondary me-1 mb-1">{{ item.insurer_document }}</span>
                    <span class="badge badge-light me-1 mb-1">{{ item.product_name }}</span>
                    <span class="badge badge-light me-1 mb-1">{{ item.date }}</span>
                  </div>
                  <div class="ms-1 fs-8" :class="this.$route.query.draft === item.id.toString() ? 'text-success' : ''">{{ item.insurer_title }}</div>
                </div>
                <div class="text-muted fs-8 p-3 pt-0 text-center">Отображаются последние 10 записей</div>
              </template>
              <div v-else class="h-100 d-flex justify-content-center align-items-center text-muted flex-column text-center">
                <i class="ki-duotone ki-brifecase-cros fs-4x mb-3 opacity-50">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                </i>
                Записи по договору <br> не найдены.
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button type="button" class="btn btn-xs btn-light" data-bs-dismiss="modal">Закрыть</button>
          <button type="button" @click="getHistory" class="btn btn-xs btn-success">Обновить</button>
        </div>
      </div>
      <div v-else class="modal-content h-100 rounded-0 w-325px">
        <loader-full style="height: 100%"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import LoaderFull from '@/components/Main/LoaderFull'
import BpmOsgpoModule from '@/helpers/Modules/Product/BpmOsgpoModule'

export default {
  name: 'PolicyHistoryPopup',
  components: {LoaderFull},
  props: {
    product: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      policies: null,
      drafts: null,
      loaded: false
    }
  },
  mounted() {
    this.getHistory()
  },
  methods: {
    goToRoute(product, id) {
      if (product === 'BpmOgpo' && !BpmOsgpoModule.Validator.isUserAllowed(this.$user)) {
        this.$notifyError({ message: 'Нет доступа к BPM ОГПО' })
        return
      }
      const myModalEl = document.getElementById('policyHistoryPopup');
      const modal     = window.bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
      this.$router.push({name: product, query: {draft:id}})
    },
    getHistory() {
      this.loaded = true;
      axios.get('/api/draft/history/' + this.product)
          .then((res) => {
            if (res.data) {
              this.drafts = res.data.drafts
              this.policies = res.data.policies
            }
          })
          .catch((err) => {
            this.$notifyError({message: err.message})
          })
          .finally(() => this.loaded = false)
    },
    getPageName(product_type) {
      const data = {
        1 : 'Ogpo',
        2 : 'Ogpo',
        3 : 'Ogpo',
        4 : 'Properties',
        5 : 'Properties',
        6 : 'Casco',
        7 : 'BpmOgpo',
      }
      return data[product_type]
    },
    getStyle(status) {
      if (status === 0) return 'badge-primary'
      if (status === 1) return 'badge-success'
      if (status === 2) return 'badge-danger'
      if (status >= 3 && status <= 8) return 'badge-warning'
    },
  }
}
</script>

<style scoped>
.modal.fade .modal-dialog {
  transform: translateX(100%);
  transition: transform 0.2s ease-out;
}

.modal.show .modal-dialog {
  transform: translateX(0);
}

.modal.fade:not(.show) .modal-dialog {
  transform: translateX(100%);
}

.policy-history-btn {
  position: fixed;
  bottom: 3%;
  right: 3%;
}
</style>